<template>
  <kst-section items-mode>
    <kst-table input-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="DispatchID"
        :label="RcvItemCatalog.DispatchID.ColumnLabel"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="RcvItemCatalog"
        />
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.Details.getItemInfo(receiveData, row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="RcvItemCatalog.Packaging.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="RcvItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="Quantity"
        :label="RcvItemCatalog.Quantity.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="RcvItemCatalog"
        />
      </b-table-column>

      <template v-if="access.Fld_Amount">
        <b-table-column numeric
          v-slot="{ column, row }"
          cell-class="ks-col-price"
          field="BuyPrice"
          :label="RcvItemCatalog.BuyPrice.Label"
        >
          <kst-output field-only
            :field="column.field" :data="row" :catalog="RcvItemCatalog"
          />
        </b-table-column>

        <b-table-column numeric
          v-slot="{ column, row }"
          cell-class="ks-col-subtotal"
          field="ExpenseAmount"
          :label="RcvItemCatalog.ExpenseAmount.Label"
        >
          <kst-output box-off field-only
            :field="column.field" :data="row" :catalog="RcvItemCatalog"
          />
        </b-table-column>
      </template>
    </kst-table>
  </kst-section>
</template>

<script>
import RcvItemCatalog from "../RcvItemCatalog.js";
import Model from "../RcvModel.js";

export default {
  props: {
    access: Object,
    receiveData: Object,
    items: Array
  },
  data: () => ({
    RcvItemCatalog: RcvItemCatalog,
    Model: Model
  })
}
</script>